import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TargetJobReportContainer from './TargetJobReportContainer';

import ArrayUtil from '../../../../utils/ArrayUtil';
import { AssessmentConstants } from '../../../../shared/Constants';

const isSubmittedAssessment = assessment => AssessmentConstants.ASMT_STATUS.SUBMITTED === assessment.status;

// eslint-disable-next-line max-len
const isMatchedTargetJob = (assessment, targetJob) => targetJob && targetJob.assessmentTemplate.id === assessment.template.id;

const sortAssessmentBySubmitDate = (a1, a2) => {
  const d1 = new Date(a1.submittedAt);
  const d2 = new Date(a2.submittedAt);
  return d2.getTime() - d1.getTime();
};

class RespondentMatchingTargetJob extends Component {
  render() {
    const {
      respondent, viewer, assessments, currentAccount, availableTranslations,
    } = this.props;
    const { targetJob } = respondent;
    const filteredAssessments = assessments
      .slice()
      .filter(asm => isSubmittedAssessment(asm) && isMatchedTargetJob(asm, targetJob))
      .sort(sortAssessmentBySubmitDate);

    let exportReport = null;

    if (ArrayUtil.isNotEmpty(filteredAssessments)) {
      exportReport = (
        <TargetJobReportContainer
          respondent={respondent}
          owner={viewer}
          currentAccount={currentAccount}
          assessment={filteredAssessments[0]}
          availableTranslations={availableTranslations}
        />
      );
    }
    return (
      <div>
        {ArrayUtil.isEmpty(filteredAssessments) && (
          <div className="jobCard-details">
            <div className="copySmall"><p>No assessments found for this target job</p></div>
          </div>
        )
        }
        <div className="jobCardSummary">{exportReport}</div>
      </div>
    );
  }
}

RespondentMatchingTargetJob.propTypes = {
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  viewer: PropTypes.objectOf(PropTypes.any).isRequired,
  assessments: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const { user } = state.app;
  return {
    viewer: {
      locale: user.locale,
    },
  };
};

export default connect(
  mapStateToProps,
  null,
)(RespondentMatchingTargetJob);
